import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'secondsToHms' })
export class SecondsToHmsPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || isNaN(value as any)) return '--:--';
    const sec = Math.max(0, Math.floor(value));
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    const hh = h > 0 ? `${h}:` : '';
    const mm = h > 0 ? String(m).padStart(2, '0') : String(m);
    const ss = String(s).padStart(2, '0');
    return `${hh}${mm}:${ss}`;
  }
}
